import { observer } from 'mobx-react-lite';
import {
    CustomIcon,
    DeleteIcon,
    DoorIcon,
    ObstacleIcon,
    RectangleIcon,
    InternalWallIcon,
    WindowIcon,
} from '../../Globle/Icon';
import RectangleButton from '../../Globle/RectangleButton';
import { useMainContext } from '../../../hooks/useMainContext';
import { message } from 'antd';
import { ButtonMode, ClosetMode } from '../../../config';

const ClosetsMapping = observer(() => {
    const { closetManager, drawingManager, viewManager } = useMainContext();
    const isDisabled = !viewManager.doUserHasAccess();

    const drawCloset = () => {
        if (isDisabled) return;
        if (closetManager.selectedPageUnit().length < 1) {
            message.error('Please Add a unit first');
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (closetManager.getUnitsInSelectedPage() == 0) {
            message.error('Please Add a unit first');
            return;
        }
        if (drawingManager.isDrawingModeOn) {
            drawingManager.setDrawingMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDoorMode(false);
        drawingManager.setRectangleMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setDrawingMode(true);
    };

    const drawRectangleCloset = () => {
        if (isDisabled) return;
        if (drawingManager.isRectangleModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        if (closetManager.selectedPageUnit().length < 1) {
            message.error('Please Add a unit first');
            return;
        }
        drawingManager.prepareCanvasForDrawing();
        if (closetManager.getUnitsInSelectedPage() == 0) {
            message.error('Please Add a unit first');
            return;
        }
        if (drawingManager.isDrawingModeOn && drawingManager.isUnitModeOn) {
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        }
        drawingManager.setDrawingMode(false);
        drawingManager.setDoorMode(false);
        drawingManager.setDrawingForm(false);
        drawingManager.setUnitMode(false);
        drawingManager.stopDrawing();
        closetManager.setObstacleForm(false);
        closetManager.setObstacleMode(false);
        drawingManager.setRectangleMode(true);
    };
    const addDoorWindow = () => {
        if (isDisabled) return;
        drawingManager.setRectangleMode(false);
        if (closetManager.selectedPageCloset().length < 1) {
            message.error('Please Add a closet first');
            return;
        }
        if (closetManager.closetMode == ClosetMode.DELETE) {
            closetManager.setDeleteMode();
        }
        viewManager.setButtonMode(ButtonMode.Closet);
        const setupBool = drawingManager.isDoorModeOn;
        drawingManager.setDoorMode(!drawingManager.isDoorModeOn);
        drawingManager.setDrawingForm(!drawingManager.drawingForm);
        drawingManager.stopDrawing();
        if (setupBool) {
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
        }
    };
    const addInternalWall = () => {
        if (isDisabled) return;
        if (closetManager.selectedPageCloset().length < 1) {
            message.error('Please Add a closet first');
            return;
        }
        drawingManager.stopDrawing();
        if (closetManager.closetMode == ClosetMode.DELETE) {
            closetManager.setDeleteMode();
        }
        viewManager.setButtonMode(ButtonMode.Closet);
        const setupBool = drawingManager.isInternalWallModeOn;
        drawingManager.setInternalWallMode(
            !drawingManager.isInternalWallModeOn,
        );
        drawingManager.setDrawingForm(false);
        drawingManager.stopDrawing();
        if (setupBool) {
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
        }
    };
    const addObstacle = () => {
        if (isDisabled) return;
        if (closetManager.selectedPageCloset().length < 1) {
            message.error('Please Add a closet first');
            return;
        }
        drawingManager.setDrawingForm(false);
        drawingManager.stopDrawing();
        if (closetManager.closetMode == ClosetMode.DELETE) {
            closetManager.setDeleteMode();
        }
        viewManager.setButtonMode(ButtonMode.Closet);
        if (closetManager.closetMode === ClosetMode.OBSTACLE) {
            closetManager.setObstacleMode(false);
            closetManager.setDistanceLabel(true);
            closetManager.drawNewClosets();
            return;
        } else {
            drawingManager.setDrawingMode(false);
            drawingManager.setRectangleMode(false);
            drawingManager.stopDrawing();
            closetManager.setObstacleMode(true);
        }
    };
    const deleteCloset = () => {
        if (isDisabled) return;
        drawingManager.setDrawingForm(false);
        if (
            closetManager.closetMode === ClosetMode.DELETE &&
            viewManager.buttonMode != ButtonMode.Door
        ) {
            closetManager.setDeleteMode();
        } else {
            if (
                (viewManager.buttonMode == ButtonMode.Closet &&
                    closetManager.selectedPageCloset().length < 1) ||
                (viewManager.buttonMode == ButtonMode.Unit &&
                    closetManager.selectedPageUnit().length < 1)
            ) {
                if (viewManager.buttonMode == ButtonMode.Closet) {
                    message.error('Please Add a closet first');
                } else {
                    message.error('Please Add a unit first');
                }
                return;
            }
            drawingManager.setRectangleMode(false);
            drawingManager.setDrawingMode(false);
            closetManager.setObstacleForm(false);
            drawingManager.stopDrawing();
            closetManager.setDeleteMode();
        }
        if (viewManager.buttonMode == ButtonMode.Door) {
            viewManager.setButtonMode(ButtonMode.Closet);
            closetManager.setDeleteMode();
            drawingManager.setDrawingMode(false);
            closetManager.setObstacleForm(false);
            drawingManager.stopDrawing();
            closetManager.setDeleteMode();
        }
    };
    const deleteDoorObstacle = () => {
        if (isDisabled) return;
        if (
            closetManager.closetMode === ClosetMode.DELETE &&
            viewManager.buttonMode == ButtonMode.Door
        ) {
            closetManager.setDeleteMode();
            viewManager.setButtonMode(ButtonMode.Closet);
        } else {
            if (
                closetManager.selectedPageAttachment().length < 1 &&
                closetManager.selectedPageObstacle().length < 1 &&
                closetManager.internalWalls.length < 1
            ) {
                message.error('Please Add a door/obstacle/Internal wall first');
                return;
            }
            viewManager.setButtonMode(ButtonMode.Door);
            drawingManager.setDrawingForm(false);
            closetManager.setDeleteMode();
            drawingManager.setRectangleMode(false);
            drawingManager.setDrawingMode(false);
            closetManager.setObstacleForm(false);
            closetManager.setInternalForm(false);
            drawingManager.stopDrawing();
            closetManager.setDeleteMode();
        }
    };
    const closetButtons = [
        {
            icon: <CustomIcon />,
            label: 'Custom',
            onClick: () => {
                drawCloset();
            },
            isActive:
                (drawingManager.isDrawingModeOn &&
                    closetManager.units.length > 0) ||
                drawingManager.isUnitModeOn,
            className: '',
            disabled: isDisabled,
        },
        {
            icon: <RectangleIcon />,
            label: 'Rectangle',
            onClick: () => {
                drawRectangleCloset();
            },
            isActive: drawingManager.isRectangleModeOn,
            className: '',
            disabled: isDisabled,
        },
        {
            icon: <DoorIcon />,
            label: 'Door / Window',
            onClick: () => {
                addDoorWindow();
            },
            isActive: drawingManager.isDoorModeOn,
            className: '',
            disabled: isDisabled,
        },
        // {
        //     icon: <WindowIcon />,
        //     label: 'Window',
        //     onClick: () => {},
        //     isActive: false,
        //     className: '',
        //     disabled: isDisabled,
        // },
        {
            icon: <ObstacleIcon />,
            label: 'Obstacle',
            onClick: () => {
                addObstacle();
            },
            isActive: closetManager.closetMode === ClosetMode.OBSTACLE,
            className: '',
            disabled: isDisabled,
        },
        {
            icon: <InternalWallIcon />,
            label: 'Internal Wall',
            onClick: () => {
                addInternalWall();
            },
            isActive: drawingManager.isInternalWallModeOn,
            className: '',
            disabled: isDisabled,
        },

        {
            icon: <DeleteIcon />,
            label: 'Delete Architecture',
            onClick: () => {
                deleteDoorObstacle();
            },
            isActive:
                drawingManager.isDeleteMode &&
                viewManager.buttonMode == ButtonMode.Door,
            className: 'pb-[1px] leading-[16px]',
            disabled: isDisabled,
        },
        {
            icon: <DeleteIcon />,
            label: 'Delete Closet',
            onClick: () => {
                deleteCloset();
            },
            isActive:
                drawingManager.isDeleteMode &&
                viewManager.buttonMode != ButtonMode.Door,
            className: '',
            disabled: isDisabled,
        },
    ];
    return (
        <div className="py-[8px] grid grid-cols-3 gap-2 closest-mapping">
            {closetButtons.map((button, index) => (
                <RectangleButton
                    key={index}
                    Icon={button.icon}
                    label={button.label}
                    onClick={button.onClick}
                    isActive={button.isActive}
                    className={`${button?.className} h-[80px]`}
                    disabled={button.disabled}
                />
            ))}
        </div>
    );
});

export default ClosetsMapping;
